import { createSelector } from '@reduxjs/toolkit';

import type { Installment, RecurringOfferWithIds } from 'models';
import type { NormalizedEntity, RootState } from 'reducers/types';

export const selectFirstOfferInstallments = createSelector(
  (state: RootState) => state.entities.recurringOffers,
  (
    recurringOffers: NormalizedEntity<RecurringOfferWithIds>,
  ): Installment[] | undefined => {
    const firstOfferId = recurringOffers.ids[0];
    if (!firstOfferId) {
      return undefined;
    }
    const firstOffer = recurringOffers.byId[firstOfferId];
    return firstOffer?.installments;
  },
);
